import { gql } from '@apollo/client';

import { interactiveLessonFragment } from '../lesson-builder.graphql';

export const GET_PUBLISHED_LESSON_ACTIVITIES_BY_VERSION = gql`
  query GetPublishedLessonActivitiesByVersion(
    $input: GetPublishedLessonActivitiesByVersionInput!
  ) {
    getPublishedLessonActivitiesByVersion(input: $input) {
      ...LessonActivities
    }
  }
  ${interactiveLessonFragment}
`;
